import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 3rem;
  border-radius: 8px;
  position: relative;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding-top: 24px;

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

export const ModalHeader = styled.div`
  width: 100%;
  background-color: white;
  top: 0;
  z-index: 20;
  align-items: start;
  justify-content: between;
  gap: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const ModalHeaderTitle = styled.span`
  font-size: 1.5rem;
  font-weight: 600;
  color: #0f363c;
  padding-right: 20px;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 2.5rem;
  cursor: pointer;
  color: #666;
  padding: 0.5rem;
  line-height: 1;

  &:hover {
    color: #333;
  }

  @media (max-width: 768px) {
    top: 8px;
    right: 8px;
  }
`;

export const Message = styled.article`
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #333;

  a {
    color: #00bfa5;
    text-decoration: underline;
    font-weight: bold;
  }
`;
